// extracted by mini-css-extract-plugin
module.exports = {"button-spinner":"_3IP1lfiJZk2QCOXuGaCwPP","spinner-color":"_3ewHXE0C0pO8DkhtVjrWsn"};